<script setup>
import { ref, watch, onMounted } from 'vue';
import transporte from '@/api/transporte';

const props = defineProps({
  turnoId: {
    type: [Number, Array],
    default: () => [],
  },
  modelValue: { type: Number, default: 0 },
});

const emit = defineEmits(['update:modelValue']);

const paradas = ref([]);

const loadParadas = (turnoId) => {
  if (!turnoId || (Array.isArray(turnoId) && !turnoId.length)) {
    paradas.value = [];
    emit('update:modelValue', 0);
    return;
  }

  const params = {
    turno_id: turnoId,
  };

  transporte.paradas.get({ params }).then((result) => {
    paradas.value = result.data;
    if (!props.modelValue && paradas.value.length > 0) {
      emit('update:modelValue', paradas.value[0].id);
    }
  });
};

watch(
  () => props.turnoId,
  (value) => {
    emit('update:modelValue', 0);
    loadParadas(value);
  },
);

onMounted(() => {
  if (props.turnoId) {
    loadParadas(props.turnoId);
  }
});
</script>

<template>
  <select
    class="form-control"
    :value="modelValue"
    @input="$emit('update:modelValue', parseInt($event.target.value))"
  >
    <option
      v-for="parada in paradas"
      :key="parada.id"
      :value="parada.id"
      :selected="parada.id == modelValue"
    >
      {{ parada.nombre }}
    </option>
  </select>
</template>
